<template>
  <div class="grid grid-cols-1">
    <div class="w-full flex gap-5">
      <QTabs
        mobile-arrows
        class="h-10 w-full rounded-full bg-dark-3 overflow-hidden"
        content-class="flex justify-start"
        indicator-color="transparent"
      >
        <template v-for="(menu,i) in menus">
          <QTab
            v-if="i+1 < menus.length"
            class="min-w-20 rounded px-10 py-2 items-center"
            :class="{'min-w-40 rounded-full bg-gradient-to-t from-secondary to-accent': i === index}"
            content-class="w-full rounded flex flex-nowrap flex-row items-center gap-4"
            @mouseover="swiper.slideTo(i)"
          >
            <SvgIcon
              :name="menu.icon"
              class="text-base"
            />
            <div
              v-if="i === index"
              class="font-bold"
            >
              {{ menu.name }}
            </div>
          </QTab>
        </template>
      </QTabs>
      <Swiper
        :slides-per-view="$q.screen.lt.md ? 2 : 3"
        :space-between="20"
        :free-mode="true"
        :navigation="true"
        :modules="swiperModules"
        :style="{
          '--swiper-navigation-color': '#04B0F8',
        }"
        @init="initSwiper"
        @slideChange="onSlideChange"
      >
        <SwiperSlide v-for="(menu,i) in menus">
          <a
            v-if="menu.route"
            :href="`#/${menu.route}`"
          >
            <div
              class="h-65 rounded"
              :class="{' border border-[#27C8E5]': i === index}"
              @mouseenter="index = i"
            >
              <QImg
                :src="menu.img"
                class="relative w-full h-full"
              />
            </div>
          </a>
        </SwiperSlide>
        <SwiperSlide v-if="$q.screen.gt.sm" />
      </Swiper>
    </div>
  </div>
</template>

<script setup>
import SvgIcon from "@/components/Icons/SvgIcon.vue";
import link1 from "@/assets/home/link-1.png";
import link2 from "@/assets/home/link-2.png";
import link3 from "@/assets/home/link-3.png";
import link4 from "@/assets/home/link-4.png";
import link5 from "@/assets/home/link-5.png";
import link6 from "@/assets/home/link-6.png";
import link7 from "@/assets/home/link-7.png";
import { ref } from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper'
import { useCycleList } from '@vueuse/core'

const menus = [
  {
    icon: 'prematches',
    name: '국내형스포츠',
    img: link1,
    route: 'prematches',
  },
  {
    icon: 'pregames',
    name: '유럽형스포츠',
    img: link2,
    route: 'pregames',
  },
  {
    icon: 'lives',
    name: '라이브스포츠',
    img: link3,
    route: 'lives',
  },
  {
    icon: 'casinos',
    name: '라이브 카지노',
    img: link4,
    route: 'casinos',
  },
  {
    icon: 'slots',
    name: '슬롯',
    img: link5,
    route: 'slots',
  },
  {
    icon: 'mini-games',
    name: '미니게임',
    img: link6,
    route: 'mini-games',
  },
  {
    icon: 'virtual-games',
    name: '가상스포츠',
    img: link7,
    route: 'virtual-games',
  },
  {},
]

const swiper = ref(null)
const swiperModules = [Navigation]
const { index } = useCycleList(menus)

function initSwiper(instance) {
  swiper.value = instance
}

function onSlideChange(instance) {
  index.value = instance.activeIndex
}

</script>
<style>
.q-tab {
  @apply min-h-10 p-0;
}
</style>